;(function($) {
    var selectCallback;

    $(".search").on("submit", function() {
        $(".search_box").val("tag:" + $(".search_box").val());
    });

    $('#homepage_slider').flexslider({
        touch: false,
        
        controlNav: true,
        animation: "fade",
        slideshowSpeed: 4*1000
    });

    $('.slider').flexslider({touch: false, controlNav: false, animation: "fade" });

    $('.slider-no-nav').flexslider({touch: false, controlNav: false, directionNav: false, animation: "fade" });

    $('.slider-no-nav-quick').flexslider({touch: false, controlNav: false, directionNav: false, animation: "fade", slideshowSpeed: 4000 });

    $('#product_slider').flexslider({
        touch: false,
        pauseOnHover: true,
        controlNav: "thumbnails",
        directionNav: false,
        
            slideshow: false,
        
        slideshowSpeed: 4*1000
    });

    $('.navicon_button').click(function() {
        $('.toggle_menu').toggle();
    });

    $('.lightbox').fancybox();

    if ($(window).width() >= 959) {
        $('.thumbnail').hover(function(){ $('.quick_shop', this).show(); }, function(){ $('.quick_shop', this).hide(); })
        $(".quick_shop").fancybox({
            width: '860px',
            height: 'auto',
            autoSize: false,
            padding: 0
        });
    }

    if ($(window).width() >= 768) {
        $('[data-fancybox="gallery"]').fancybox({ loop: true });
        
    }

    $('.flex-control-thumbs img').click(function(e) {
        var optionValue = $(this).attr('alt');
        var $selector = $('select.single-option-selector:contains(' + optionValue + ')');
        if ($selector.length && $selector.val() != optionValue) {
            $selector.val(optionValue).trigger('change');
        }
    });

    $('#tag_filter').change(function() { window.location = $('#tag_filter option:selected').val(); });
    $('.update_subtotal').click(function() { $("#cart_form").submit(); return false; });
    $("#cart_form input[type='number']").change(function() {$("#cart_form").submit(); });

    var tabs = $('ul.tabs');
    tabs.each(function(i) {
        var tab = $(this).find('> li > a');
        tab.click(function(e) {
            var contentLocation = $(this).attr('href');
            if(contentLocation.charAt(0)=="#") {
                e.preventDefault();
                tab.removeClass('active');
                $(this).addClass('active');
                $(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
            }
        });
    });

    $('.toggle').click(function() {
        if ($(window).width() <= 767) {
            var $toggle = $(this);
            if($toggle.next('ul').is(':visible')) {
                $toggle.next('ul').hide();
                $toggle.children('span').html('+');
            } else {
                $toggle.next('ul').show();
                $toggle.children('span').html('-');
            }
        }
    });

    selectCallback = function(variant, selector) {
        var $product = $('#product-' + selector.product.id);
        var $notify_form = $('#notify-form-' + selector.product.id);

        if (variant) {
            var $thumbs = $('.flex-control-thumbs img', $product);
            var optionValue = variant.options[$('form.product_form', $product).data('option-index')];

            for (var i = 0; i < selector.product.options.length; i++) {
                var option = selector.product.options[i];
                var optionNumber = i + 1;
                var selectedOption = variant['option' + optionNumber];
                var $swatchGroup = $('.options[data-option="' + option + '"]');
                var $options = $('[data-option-title]', $swatchGroup);
                var $selected = $('[data-option-title="' + selectedOption + '"]', $swatchGroup);
                $options.removeClass('selected');
                $selected.addClass('selected');
            }

            $.each($thumbs, function(index, value) {
                if($(value).attr('alt') == optionValue && !$(value).hasClass('flex-active')) {
                    $(value).click();
                    return false;
                }
            });
        }

        if (variant && variant.available == true) {
            if(variant.price < variant.compare_at_price){
                $('.total_price .was_price', $product).html(Shopify.formatMoney(variant.compare_at_price, $('form.product_form', $product).data('money-format')))
            } else {
                $('.total_price .was_price', $product).text('')
            }
            $('.total_price .sold_out', $product).text('');
            $('.total_price .current_price', $product).html(Shopify.formatMoney(variant.price, $('form.product_form', $product).data('money-format')));
            $('#add-to-cart', $product).removeClass('disabled').removeAttr('disabled').val('Add to Cart');
            $notify_form.hide();
        } else {
            var message = variant ? "Sold Out" : "Out of Stock";
            $('.total_price .was_price', $product).text('')
            $('.total_price .current_price', $product).text('')
            $('.total_price .sold_out', $product).text(message);
            $('#add-to-cart', $product).addClass('disabled').attr('disabled', 'disabled').val(message);
            $notify_form.fadeIn();
        }
    };

    var productOptionInstances = [];
    $('.product_form.product_form_options.init').each(function(i, elem) {
        productOptionInstances.push(new Shopify.OptionSelectors($(elem).data("select-id"), { product: $(elem).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(elem).data("enable-state") }));

        const $options = $('.single-option-selector', $(elem));
        $options.each(function(i, option) {
            const labelText = $(option.labels && option.labels[0]).text().trim().toLowerCase();

            if (labelText.indexOf('color') > -1 || labelText.indexOf('colour') > -1 || labelText.indexOf('upholstery') > -1 || labelText.indexOf('top') > -1 || labelText.indexOf('seat') > -1 || labelText.indexOf('base') > -1 || labelText.indexOf('frame') > -1 || labelText.indexOf('leg') > -1 || labelText.indexOf('body') > -1 || labelText.indexOf('box') > -1 || labelText.indexOf('sides') > -1 || labelText.indexOf('finish') > -1 || labelText.indexOf('feat') > -1 || labelText.indexOf('exterior') > -1 || labelText.indexOf('interior') > -1) {
                $(option).closest('.selector-wrapper').hide();
            }
        });
    });

    // BEGIN SWATCHES
    var $swatches = $('.swatch');
    $('[data-option-title]', $swatches).on('click', function(event) {
        var $target = $(event.currentTarget);
        var optionValue = $target.attr('data-option-title'); // what have I just clicked on?

        event.preventDefault();

        $('.single-option-selector option')
            .filter(function(i, elem) {
                return $(elem).text() == optionValue
            })
            .parent()
            .val(optionValue)
            .trigger('change');

        return false;
    });
    // END SWATCHES

    // Quantity Buttons
    $('.quantity-btns').each(function(i, elem) {
        var $this = $(elem);
        var $qty = $('input[name="quantity"]', $this);

        $('button', $this).on('click', function(event) {
            var $clicked = $(event.currentTarget);
            var quantity = parseInt($qty.val(), 10);
            if ($clicked.hasClass('increment')) quantity++;
            else if ($clicked.hasClass('decrement') && quantity > 1) quantity--;

            $qty.val(quantity);
        });
    });
})(jQuery);
